import { useEffect } from 'react';
import { autorun } from 'mobx';
import { StreemAPI, StreemApiGetCompanyRoomOutcomeConfigResponse } from '@streem/api';
import { ToastTypes } from '@streem/ui-react';
import { UIStore } from '../stores/ui_store';
import { CompanySettingsStore } from '../stores/company_settings_store';
import appLogger from '../util/logging/app_logger';

export const getCompanyRoomOutcomeConfig = async (
    companyCodeOrSid: string,
): Promise<StreemApiGetCompanyRoomOutcomeConfigResponse> => {
    const response = await StreemAPI.companies.getCompanyRoomOutcomeConfig(companyCodeOrSid);
    return response;
};

export const useLoadRoomOutcomeFormConfig = (
    companySettingsStore: CompanySettingsStore,
    uiStore?: UIStore,
    companyCodeOrSid?: string,
): void => {
    useEffect(() => {
        const disposer = autorun(async () => {
            if (!companySettingsStore.complete) return;
            try {
                await companySettingsStore.loadDispositionConfigDetails(companyCodeOrSid);
            } catch (error) {
                appLogger.error('Failed to load room outcome config details', error);
                uiStore?.addToastWithManualClose({
                    content: `Failed to load call disposition, please refresh web browser`,
                    flavor: ToastTypes.ERROR,
                    id: `room-outcome-error`,
                });
            }
        });

        return () => disposer();
    }, [companyCodeOrSid, companySettingsStore, uiStore]);
};
